import { useEffect, useState, useRef } from 'react';
import { useHistory, useLocation } from '../../hooks/useRouterCompat';
import Page from '../../const/Page';
import LeftMenuRooms from '../rooms/LeftMenuRooms';
import LeftMenuSoribot from '../soribots/LeftMenuSoribot';
import RejoinRoomCallModal from './RejoinRoomCallModal';

const LeftMenu: React.FC = () => {
  const location = useLocation();

  // 초기값을 현재 경로에 따라 설정 (첫 렌더링부터 올바른 메뉴 표시)
  const getMenuTypeFromPath = (path: string): 'room-menu' | 'workspace-admin' | 'soribot-menu' | 'hidden' => {
    if (!path) return 'room-menu';
    if (path.startsWith('/ws-admin')) return 'workspace-admin';
    if (path.startsWith(Page.publicSharePage) || path.startsWith(Page.publicBotPage)) return 'hidden';
    if (path.startsWith(Page.soribot)) return 'soribot-menu';
    return 'room-menu';
  };

  const [menuType, setMenuType] = useState<'room-menu' | 'workspace-admin' | 'soribot-menu' | 'hidden'>(
    () => getMenuTypeFromPath(location.pathname)
  );

  useEffect(() => {
    updateMenuType(location.pathname);
  }, [location.pathname])

  function updateMenuType(path: string) {
    if (path) {
      if (path.startsWith('/ws-admin')) {
        setMenuType('workspace-admin');
      } else if (path.startsWith(Page.publicSharePage) || path.startsWith(Page.publicBotPage)) {
        setMenuType('hidden');
      } else if (path.startsWith(Page.soribot)) {
        setMenuType('soribot-menu');
      } else {
        setMenuType('room-menu');
      }
    }
  }

  if (menuType == 'hidden') return null;

  return (
    <div className='left-menu h-full flex flex-col bg-white'>
      {menuType == 'room-menu' && <LeftMenuRooms />}
      {menuType == 'soribot-menu' && <LeftMenuSoribot />}
      <RejoinRoomCallModal />
    </div>
  );
};


export default LeftMenu;


